import { render } from "./myleads_today.vue?vue&type=template&id=cf230622&scoped=true"
import script from "./myleads_today.vue?vue&type=script&lang=js"
export * from "./myleads_today.vue?vue&type=script&lang=js"

import "./myleads_today.vue?vue&type=style&index=0&id=cf230622&lang=scss&scoped=true"

import exportComponent from "D:\\workspace\\front\\syb\\syb_webchat\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cf230622"]])

export default __exports__